import joi from 'joi';

export const keywordsSchema = joi.array().items(joi.string()).default([]);

export default keywordsSchema;
